import * as React from 'react';
//import { default as Transition } from 'react-transition-group/Transition'; // TODO: when the definition file is fixed
const Transition = require('react-transition-group/Transition').default;

export type Props = {
    id?: string;
    visible: boolean;
    duration: number | { enter?: number; exit?: number };
    children: React.ReactNode;
    unmountOnExit?: boolean;
    style?: object;
    className?: string;
    element?: string;
};

type TransitionState = 'entering' | 'entered' | 'exiting' | 'exited';

const styles = {
    entering: { opacity: 1 },
    entered:  { opacity: 1 },
    exiting:  { opacity: 0 },
    exited:   { opacity: 0, pointerEvents: 'none' },
};

export const Fade = ({ id, visible, duration, children, unmountOnExit = false, className = '', style = {}, element = 'div' }: Props) => {
    const durationIn = typeof duration === 'number' ? duration : duration.enter;
    const durationOut = typeof duration === 'number' ? duration : duration.exit;
    return (
        <Transition in={ visible } timeout={ duration }>
            { (state: TransitionState) =>
                React.createElement(
                    element,
                    {
                        id,
                        className: `${className} fade-${state}`,
                        style: {
                            transition: `opacity ${state === 'entering' || state === 'entered' ? durationIn : durationOut}ms ease-out`,
                            ...styles[state],
                            ...style,
                        },
                    },
                    (state !== 'exited' || !unmountOnExit) ? children : [],
                )
            }
        </Transition>
    );
};



// WEBPACK FOOTER //
// ./src/ui/transitions/Fade.tsx